import FormErrorModel from './form-error.model';

class RequestProductFormModel {
    constructor() {
        this.requestProducts = {};

        this.error = new FormErrorModel();
    }

    getRequestProducts() {
        return this.requestProducts;
    }

    setRequestProducts(requestProducts) {
        this.requestProducts = requestProducts;
    }

    getRequestProduct(code) {
        return this.requestProducts[code];
    }

    setFormErrors(errors) {
        this.error.setFormErrors(errors);
    }

    toPayload() {
        let payload = {
            memberProductList: {
                memberProducts: {}
            }
        };

        angular.forEach(this.requestProducts, (requestProduct, code) => {
            if (requestProduct.isSelected) {
                payload.memberProductList.memberProducts[code] = {
                    product: code,
                    username: requestProduct.username,
                    isAgree: requestProduct.isAgree,
                };
            }
        });

        return payload;
    }
}

export default RequestProductFormModel;



// WEBPACK FOOTER //
// ./client/app/shared/system-components/request-product/model/form.model.js